import $ from "jquery";

const Search = (el) => {
    const $el = $(el);
    const $menu = $(".header-menu");
    const className = "header-menu--search-open";

    $el.on("click", function () {
        if ($menu.hasClass(className)) {
            $menu.removeClass(className);
        } else {
            $menu.addClass(className);
        }
    });
};

export default Search;
